// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"44ab5fd5","676":"c4ce247c"}[chunkId] + ".chunk.css";
};